/// <amd-module name="Wit/MarkdownEditorReduxAdapter/MarkdownPreviewRenderer" />
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import * as React from "react";
import { connect } from "react-redux";
import { getMarkdownStateByKey } from "Redux/MarkdownEditorSelector";
import { MarkdownActions } from "Wit/MarkdownEditorReduxAdapter/Redux/MarkdownEditorActions";
import { IMarkdownEditorAwareState, IMarkdownEditorKey, MarkdownPreviewState } from "Wit/MarkdownEditorReduxAdapter/Redux/MarkdownEditorContracts";
import * as Resources from "Wit/MarkdownEditorReduxAdapter/Resources";

interface IMarkdownPreviewRendererProps {
    lookupKey: IMarkdownEditorKey;
    markdown: string;
}

interface IMarkdownPreviewRendererPropsFromState {
    html: string | undefined;
    previewState: MarkdownPreviewState;
}

class MarkdownPreviewRenderer extends React.Component<IMarkdownPreviewRendererProps & IMarkdownPreviewRendererPropsFromState & typeof Actions> {
    public render(): JSX.Element {
        const { html = "", previewState } = this.props;
        if (previewState === MarkdownPreviewState.NotAvailable) {
            return (
                <Spinner size={SpinnerSize.large} label={Resources.Loading} />
            );
        }
        if (previewState === MarkdownPreviewState.Available) {
            return <div className="server-side-rendered-markdown" dangerouslySetInnerHTML={{ __html: html }} />
        }
        return <>{Resources.Error}</>;
    }

    public componentDidMount() {
        this.props.loadPreview(this.props.lookupKey, this.props.markdown);
    }

    public componentWillUnmount() {
        this.props.resetPreview(this.props.lookupKey);
    }
}

function mapStateToProps(state: IMarkdownEditorAwareState, providedProps: IMarkdownPreviewRendererProps): IMarkdownPreviewRendererPropsFromState {
    const { lookupKey } = providedProps;
    const markdownState = getMarkdownStateByKey(state, lookupKey);
    return {
        html: markdownState.previewValue,
        previewState: markdownState.previewState
    };
}

const Actions = {
    loadPreview: MarkdownActions.previewRequested,
    resetPreview: MarkdownActions.resetPreviewState
};

export const ConnectedMarkdownPreviewRenderer = connect(
    mapStateToProps,
    Actions
)(MarkdownPreviewRenderer);
